const viewAny = (permissions) => {
  return permissions.includes('read-lead-sources')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-lead-sources')
}

const update = (permissions, leadSource) => {
  return hasPermission(permissions, 'update-lead-sources')
}

const deletee = (permissions, leadSource) => {
  return hasPermission(permissions, 'delete-lead-sources')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};